import { createContext } from "react";

const ShoppingCartContext = createContext(null);

export default ShoppingCartContext;
